export default __webpack_public_path__ + "static/media/ActionFun.f48c634f.jpg";